import { create } from 'zustand'
import api from '../api/client'

const useAppStore = create((set, get) => ({
  condominios: [],
  condominioAtivo: null,
  loading: false,

  fetchCondominios: async () => {
    set({ loading: true })
    try {
      const { data } = await api.get('/condominios')
      const lista = data
      const ativo = lista[0] || null
      set({ condominios: lista, condominioAtivo: ativo, loading: false })
    } catch {
      set({ loading: false })
    }
  },

  setCondominioAtivo: (condo) => set({ condominioAtivo: condo })
}))

export default useAppStore
